<template>
    <img v-if="avatarURL" class="outline-none" alt="user image" :src="avatarURL" />
    <div v-else class="skeleton outline-none" />
</template>

<script lang="ts">
import { md5 } from 'hash-wasm';
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
    props: {
        email: {
            type: String,
            required: false,
            default: undefined,
        },
    },

    setup(props) {
        const avatarURL = ref<null | string>(null);

        const setAvatarURL = async (email?: string) => {
            if (!email) return;

            let hash;

            const normalized = email.trim().toLowerCase();

            try {
                // Gravatar supports SHA-256 hashes now
                const msgBuffer = new TextEncoder().encode(normalized);
                const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                hash = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
            } catch (e) {
                console.error(e);

                hash = await md5(normalized);
            }

            avatarURL.value = `https://www.gravatar.com/avatar/${hash}?s=160`;
        };

        setAvatarURL(props.email);
        watch(
            () => props.email,
            (value) => setAvatarURL(value),
        );

        return {
            avatarURL,
        };
    },
});
</script>
